import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Wrench } from 'lucide-react';

const OccasionReparateurs = () => (
  <section className="max-w-7xl mx-auto px-4 py-12">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-gradient-to-br from-[#FFF3E0] to-[#FAF7F2] border border-[#E8D5C0] rounded-2xl p-8 flex flex-col">
        <div className="w-14 h-14 rounded-2xl bg-[#C75B27]/10 flex items-center justify-center mb-4"><Package className="w-7 h-7 text-[#C75B27]" /></div>
        <h2 className="font-serif text-2xl font-semibold text-[#2D2A26] mb-2">Matériel d'occasion</h2>
        <p className="text-[#7A6F5C] text-sm mb-6 flex-1">
          Achetez et vendez votre matériel dentaire d'occasion entre professionnels.
          Fauteuils, radios, turbines, autoclaves... avec options SAV et livraison.
        </p>
        <div className="flex gap-3 flex-wrap">
          <Link to="/occasion" className="bg-[#C75B27] hover:bg-[#a84d21] text-white px-6 py-3 rounded-xl font-semibold text-sm transition-colors">
            Voir les annonces
          </Link>
          <Link to="/occasion" className="border border-[#C75B27] text-[#C75B27] hover:bg-[#FFF3E0] px-6 py-3 rounded-xl font-semibold text-sm transition-colors">
            Déposer une annonce
          </Link>
        </div>
      </div>
      <div className="bg-gradient-to-br from-[#E4EDE9] to-[#FAF7F2] border border-[#C5D9CF] rounded-2xl p-8 flex flex-col">
        <div className="w-14 h-14 rounded-2xl bg-[#1F4D3F]/10 flex items-center justify-center mb-4"><Wrench className="w-7 h-7 text-[#1F4D3F]" /></div>
        <h2 className="font-serif text-2xl font-semibold text-[#2D2A26] mb-2">Réparateurs agréés</h2>
        <p className="text-[#7A6F5C] text-sm mb-6 flex-1">
          Trouvez un technicien qualifié près de chez vous pour réparer votre matériel dentaire.
          Intervention rapide, devis gratuit, notes vérifiées.
        </p>
        <div className="flex gap-3 flex-wrap">
          <Link to="/reparateurs" className="bg-[#1F4D3F] hover:bg-[#173B30] text-white px-6 py-3 rounded-xl font-semibold text-sm transition-colors">
            Trouver un technicien
          </Link>
          <Link to="/inscription?role=reparateur" className="border border-[#1F4D3F] text-[#1F4D3F] hover:bg-[#E4EDE9] px-6 py-3 rounded-xl font-semibold text-sm transition-colors">
            Devenir technicien
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default OccasionReparateurs;
